import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Bookmark, Heart, Play } from "lucide-react";
import ScrollingText from "@/components/ui/scrolling-text";

interface QueueItemProps {
  imageUrl?: string;
  title?: string;
  duration?: string;
  listens?: number;
  likes?: number;
  isActive?: boolean;
  isBookmarked?: boolean;
  onClick?: () => void;
  onPodcastClick?: () => void;
}

const QueueItem = ({
  imageUrl = "https://dummyimage.com/72/f4f4f4/666666&text=Thumbnail",
  title = "Queue Item Title",
  duration = "3:00",
  listens = 0,
  likes = 0,
  isActive = false,
  isBookmarked = false,
  onClick = () => {},
  onPodcastClick,
}: QueueItemProps) => {
  const formatNumber = (num: number) => {
    if (num >= 1000000) {
      return `${(num / 1000000).toFixed(1)}M`;
    }
    if (num >= 1000) {
      return `${(num / 1000).toFixed(1)}K`;
    }
    return num.toString();
  };

  return (
    <div
      className={`w-full h-[72px] hover:bg-white/5 flex items-center gap-4 px-4 py-3 cursor-pointer transition-colors border-b border-white/15 ${isActive ? "bg-white/5" : ""}`}
      onClick={onClick}
    >
      <div
        className="relative w-[48px] h-[48px] flex-shrink-0 overflow-hidden rounded-lg cursor-pointer"
        onClick={(e) => {
          e.stopPropagation();
          onPodcastClick?.();
        }}
      >
        <AspectRatio ratio={1}>
          <img
            src={imageUrl}
            alt={title}
            className="object-cover w-full h-full"
          />
        </AspectRatio>
        {isBookmarked && (
          <div className="absolute top-1 left-1 bg-blue-500 rounded-sm p-1">
            <Bookmark className="h-3 w-3 text-white fill-current" />
          </div>
        )}
      </div>

      <div className="flex-grow min-w-0">
        <ScrollingText
          text={title}
          className="text-sm font-medium text-gray-800"
        />
        <div className="flex items-center gap-3 mt-1">
          <div className="flex items-center gap-1 text-xs text-gray-600">
            <Play className="h-3 w-3" />
            <span>{formatNumber(listens)}</span>
          </div>
          <div className="flex items-center gap-1 text-xs text-gray-600">
            <Heart className="h-3 w-3" />
            <span>{formatNumber(likes)}</span>
          </div>
        </div>
      </div>

      <div className="text-xs text-gray-600 flex-shrink-0">{duration}</div>
    </div>
  );
};

export default QueueItem;
